import { render, staticRenderFns } from "./PcPcmRegnSearch.vue?vue&type=template&id=64b542a0&"
import script from "./PcPcmRegnSearch.vue?vue&type=script&lang=js&"
export * from "./PcPcmRegnSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports